import { createRouter, createWebHashHistory } from "vue-router";

import { store } from "../store";
import { PermissionEnum } from "../repositories";
import { UITR } from "../translation";

import defaultLayout from "./../../layouts/side-nav-top-toolbar";
import simpleLayout from "./../../layouts/single-card";
import simpleLayoutWide from "./../../layouts/single-card-wide";

function loadView(view) {
    return () => import(/* webpackChunkName: "login" */ `./../../views/${view}.vue`)
}

export function hasPermission(permission) {

    var permissions = store.getters["account/permissions"];

    if (permissions.includes(PermissionEnum.Administrator))
        return true;

    var retVal = false;
    if (Array.isArray(permission)) {
        permission.forEach(e => {
            if (!Number.isInteger(e))
                throw 'hasPermission(permission), parameter is not a number ' + e;
            if (permissions.includes(e)) {
                retVal = true;
                return;
            }
        });
    }
    else {
        if (!Number.isInteger(permission))
            throw 'hasPermission(permission), parameter is not a number ' + permission;

        return permissions.includes(permission);
    }

    return retVal;
}

export function hasRoutePermission(routeRecord) {
    if (routeRecord.path === undefined)
        return false;

    var isAdmin = store.getters["account/permissions"].includes(PermissionEnum.Administrator);
    var hasPermission = typeof routeRecord?.meta?.hasPermission !== "function" || routeRecord.meta.hasPermission(store.getters["account/permissions"]);
    return isAdmin || hasPermission;
}

export const router = new createRouter({
    routes: [
        {
            path: "/test",
            name: "test",
            meta: {
                requiresAuth: false,
                layout: defaultLayout
            },
            component: loadView("test/test-parent")
        },
        {
            path: "/home",
            name: "home",
            meta: {
                requiresAuth: true,
                layout: defaultLayout
            },
            component: loadView("home/dashboard-main")
        },
        {
            path: "/password-reset",
            name: "Password Reset", // Changed from "password reset" for consistency
            meta: {
                requiresAuth: true,
                layout: simpleLayoutWide
            },
            component: loadView("password-reset-form")
        },
        {
            path: "/users/users-browse",
            name: "Users",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.users_usersBrowse) || permissions.includes(PermissionEnum.users);
                }
            },
            component: loadView("users/users-browse")
        },
        {
            path: "/users/users-detail",
            name: "User",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.users_usersDetail) || permissions.includes(PermissionEnum.users);
                }
            },
            component: loadView("users/users-detail")
        },
        {
            path: "/shipment/shipment-browse",
            name: "shipments",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.shipment_shipmentBrowse) || permissions.includes(PermissionEnum.shipment);
                }
            },
            component: loadView("shipment/shipment-browse")
        },
        {
            path: "/shipment/shipment-template-browse",
            name: "standart shipments",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.shipment_shipmentTemplateBrowse) || permissions.includes(PermissionEnum.shipment);
                }
            },
            component: loadView("shipment/shipment-template-browse")
        },
        {
            path: "/shipment/shipment-detail",
            name: "shipment",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.shipment_shipmentDetail) || permissions.includes(PermissionEnum.shipment);
                }
            },
            component: loadView("shipment/shipment-detail")
        },
        {
            path: "/shipment/shipment-template-detail",
            name: "shipment template",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.shipment_shipmentDetail) || permissions.includes(PermissionEnum.shipment);
                }
            },
            component: loadView("shipment/shipment-detail")
        },


        {
            path: "/shipment/shipment-carrier-bid",
            name: "shipment-carrier-bid",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return true;
                }
            },
            component: loadView("shipment/shipment-carrier-bid")
        },
        {
            path: "/shipment/shipment-carrier-winner",
            name: "shipment-carrier-winner",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return true;
                }
            },
            component: loadView("shipment/shipment-carrier-winner")
        },
        {
            path: "/users/user-options-detail",
            name: "User Options",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.users_userOptionsDetail) || permissions.includes(PermissionEnum.users)
                }
            },
            component: loadView("users/user-options-detail")
        },
        {
            path: "/permission/permission-group-browse",
            name: "Permissions",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.permission_permissionGroupBrowse) || permissions.includes(PermissionEnum.permission);
                }
            },
            component: loadView("permission/permission-group-browse")
        },
        {
            path: "/permission/permission-group-detail",
            name: "Permission Group",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.permission_permissionGroupDetail) || permissions.includes(PermissionEnum.permission);
                }
            },
            component: loadView("permission/permission-group-detail")
        },
        {
            path: "/number-generator/number-generator-browse",
            name: "Number Generators",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.numberGenerator_numberGeneratorBrowse) || permissions.includes(PermissionEnum.numberGenerator);
                }
            },
            component: loadView("number-generator/number-generator-browse")
        },
        {
            path: "/number-generator/number-generator-detail",
            name: "Number Generator",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.numberGenerator_numberGeneratorDetail) || permissions.includes(PermissionEnum.numberGenerator);
                }
            },
            component: loadView("number-generator/number-generator-detail")
        },
        {
            path: "/carrier/carrier-browse",
            name: "Carriers",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.carrier_carrierBrowse) || permissions.includes(PermissionEnum.carrier);
                }
            },
            component: loadView("carrier/carrier-browse")
        },
        {
            path: "/carrier/carrier-detail",
            name: "Carrier",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.carrier_carrierDetail) || permissions.includes(PermissionEnum.carrier);
                }
            },
            component: loadView("carrier/carrier-detail")
        },




        {
            path: "/shipment-address/shipment-address-browse",
            name: "Addresses", // Changed from "Adresy"
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.shipmentAddress_shipmentAddressBrowse) || permissions.includes(PermissionEnum.shipmentAddress);
                }
            },
            component: loadView("shipment-address/shipment-address-browse")
        },
        {
            path: "/shipment-address/shipment-address-detail",
            name: "Address", // Changed from "Adresa"
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.shipmentAddress_shipmentAddressDetail) || permissions.includes(PermissionEnum.shipmentAddress);
                }
            },
            component: loadView("shipment-address/shipment-address-detail")
        },
        {
            path: "/shipment-address-state/shipment-address-state-browse",
            name: "Addresses (States)", // Changed from "Adresy (Státy)"
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.shipmentAddressState_shipmentAddressStateBrowse) || permissions.includes(PermissionEnum.shipmentAddressState);
                }
            },
            component: loadView("shipment-address-state/shipment-address-state-browse")
        },
        {
            path: "/shipment-address-state/shipment-address-state-detail",
            name: "Address (State)", // Changed from "Adresa (Stát)"
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.shipmentAddressState_shipmentAddressStateDetail) || permissions.includes(PermissionEnum.shipmentAddressState);
                }
            },
            component: loadView("shipment-address-state/shipment-address-state-detail")
        },
        {
            path: "/currency/currency-browse",
            name: "currencies",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.currency_currencyBrowse) || permissions.includes(PermissionEnum.currency);
                }
            },
            component: loadView("currency/currency-browse")
        },
        {
            path: "/currency/currency-detail",
            name: "currency",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.currency_currencyDetail) || permissions.includes(PermissionEnum.currency);
                }
            },
            component: loadView("currency/currency-detail")
        },


        //{
        //    path: "/account/account-browse",
        //    name: "accounts",
        //    meta: {
        //        requiresAuth: true,
        //        layout: defaultLayout,
        //        hasPermission: (permissions) => {
        //            return permissions.includes(PermissionEnum.account_accountBrowse) || permissions.includes(PermissionEnum.account);
        //        }
        //    },
        //    component: loadView("account/account-browse")
        //},
        //{
        //    path: "/account/account-detail",
        //    name: "account",
        //    meta: {
        //        requiresAuth: true,
        //        layout: defaultLayout,
        //        hasPermission: (permissions) => {
        //            return permissions.includes(PermissionEnum.account_accountDetail) || permissions.includes(PermissionEnum.account);
        //        }
        //    },
        //    component: loadView("account/account-detail")
        //},


        {
            path: "/element-help/element-help-browse",
            name: "Elements Help",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.elementHelp_elementHelpBrowse) || permissions.includes(PermissionEnum.elementHelp);
                }
            },
            component: loadView("element-help/element-help-browse")
        },
        {
            path: "/element-help/element-help-detail",
            name: "Element Help",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.elementHelp_elementHelpDetail) || permissions.includes(PermissionEnum.elementHelp);
                }
            },
            component: loadView("element-help/element-help-detail")
        },


        {
            path: "/event-log/event-log-browse",
            name: "Event Log",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.eventLog_eventLogBrowse) || permissions.includes(PermissionEnum.eventLog);
                }
            },
            component: loadView("event-log/event-log-browse")
        },
        {
            path: "/event-log/event-log-detail",
            name: "Event Log Detail",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
            },
            component: loadView("event-log/event-log-detail")
        },
        {
            path: "/app-config",
            name: "Application Config",
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.appConfig);
                }
            },
            component: loadView("app-config")
        },
        {
            path: "/hangfire",
            name: "Hangfire",
            meta: {
                requiresAuth: true,
                hasPermission: (permissions) => {
                    return permissions.includes(PermissionEnum.AdministratorHangfire);
                }
            },
        },
        {
            path: "/login-form",
            name: "login-form",
            meta: {
                requiresAuth: false,
                layout: simpleLayout,
                title: "Sign In"
            },
            component: loadView("login-form")
        },
        {
            path: "/",
            redirect: "/home"
        },
        {
            path: "/recovery",
            redirect: "/home"
        },
        {
            path: "/:pathMatch(.*)*",
            redirect: "/home"
        }
    ],
    history: createWebHashHistory(),
});

router.beforeEach((to, from, next) => {

    var sessionID = store.getters["account/sessionID"];
    if (sessionID && to.query.sessionID && sessionID != to.query.sessionID) {
        to.query.sessionID = null;
        store._actions["account/logout"][0]({ clientOnly: true, sessionID: sessionID });
        loginRedirect(to, next);
        return;
    }

    var isAuthenticated = store.getters["account/isAuthenticated"] == true;

    if (to.name === "login-form" && isAuthenticated) {
        homeRedirect(next);
        return;
    }

    if (!to.query.sessionID && sessionID)
        to.query.sessionID = sessionID;

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isAuthenticated) {
            loginRedirect(to, next);
        }
        else {
            var cannotRoute = to.matched.some(record => !hasRoutePermission(record));
            if (cannotRoute) {
                if (from.name == "login-form")
                    homeRedirect(next);
                else
                    next(from);
            }
            else
                next();
        }
    }
    else {
        next();
    }
});

router.afterEach((to, from) => {
    var id = "";
    if (to.query.id)
        id = " (" + to.query.id + ")";
    window.document.title = "TL " + to.name + id;
})

function homeRedirect(next) {
    next({ name: "home" });
}

function loginRedirect(to, next) {

    to.query.redirect = encodeURIComponent(to.fullPath);
    next({
        name: "login-form",
        query: to.query
    });
}

export function navigation() {
    const t = UITR;
    
    return [
        {
            text: t.UI.Menu.Home.tr,
            path: "/home",
            icon: "home"
        },
        {
            text: t.UI.Menu.Browse.tr,
            icon: "folder",
            items: [
                {
                    text: t.UI.Menu.Users.tr,
                    path: "/users/users-browse"
                },
                {
                    text: t.UI.Menu.Shipments.tr,
                    path: "/shipment/shipment-browse"
                },
            ]
        },
        {
            text: t.UI.Menu.Tools.tr,
            icon: "toolbox",
            items: [
                {
                    text: t.UI.Menu.EventLog.tr,
                    path: "/event-log/event-log-browse"
                },
            ]
        },
        {
            text: t.UI.Menu.Settings.tr,
            icon: "preferences",
            items: [
                {
                    text: t.UI.Menu.ApplicationConfig.tr,
                    path: "/app-config"
                },
                {
                    text: t.UI.Menu.Carriers.tr,
                    path: "/carrier/carrier-browse"
                },
                {
                    text: t.UI.Menu.Addresses.tr,
                    path: "/shipment-address/shipment-address-browse"
                },
                {
                    text: t.UI.Menu.AddressesStates.tr,
                    path: "/shipment-address-state/shipment-address-state-browse"
                },
                {
                    text: t.UI.Menu.Currencies.tr,
                    path: "/currency/currency-browse"
                },
                {
                    text: t.UI.Menu.NumberGenerator.tr,
                    path: "/number-generator/number-generator-browse"
                },
                {
                    text: t.UI.Menu.PermissionGroup.tr,
                    path: "/permission/permission-group-browse"
                },
                {
                    text: t.UI.Menu.ElementHelp.tr,
                    path: "/element-help/element-help-browse"
                }
            ]
        },
        {
            text: t.UI.Menu.Hangfire.tr,
            path: "/hangfire",
            icon: "clock",
            isExternalNavigation: true
        }
    ];
}